import { render, staticRenderFns } from "./WarehouseViewValue.vue?vue&type=template&id=f3e8e4a2"
import script from "./WarehouseViewValue.vue?vue&type=script&lang=js"
export * from "./WarehouseViewValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports